// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pin-auth-page {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.pin-auth-page .pin-card {
  width: 100%;
  max-width: 420px;
  padding: 36px 28px;
  border-radius: 26px;
  background: rgba(0, 0, 0, 0.85);
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(18px);
  text-align: center;
  color: #ffffff;
  animation: cardFadeIn 0.6s ease;
}
.pin-auth-page .pin-card h2 {
  margin: 14px 0 8px;
  font-size: 28px;
  font-weight: 700;
}
.pin-auth-page .pin-card p {
  margin: 0 0 28px;
  color: #cbd5e1;
  font-size: 15px;
}
.pin-auth-page .pin-icon {
  width: 78px;
  height: 78px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #8b5cf6, #06b6d4);
  box-shadow: 0 12px 35px rgba(139, 92, 246, 0.5);
  animation: pulseIcon 1.8s infinite;
}
.pin-auth-page .pin-icon span {
  font-size: 36px;
}
.pin-auth-page .pin-back-btn {
  position: absolute;
  top: 18px;
  left: 18px;
  border: none;
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  padding: 9px 14px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}
.pin-auth-page .pin-back-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.22);
  transform: translateX(-3px);
}
.pin-auth-page .pin-back-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pin-auth-page .pin-input-group {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-bottom: 16px;
}
.pin-auth-page .pin-input-group input {
  width: 70px;
  height: 72px;
  border-radius: 18px !important;
  border: 2px solid rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.14);
  color: transparent !important;
  -webkit-text-fill-color: transparent !important;
  text-shadow: none;
  font-size: 80px !important;
  font-weight: 700;
  text-align: center;
  outline: none;
  transition: all 0.25s ease;
  padding-bottom: 20px;
  caret-color: transparent;
}
.pin-auth-page .pin-input-group input.pin-input--filled {
  background: radial-gradient(circle at center, #030303 0 9px, transparent 10px), rgba(255, 255, 255, 0.14);
}
.pin-auth-page .pin-input-group input:focus {
  border-color: #22d3ee;
  box-shadow: 0 0 0 4px rgba(34, 211, 238, 0.2);
  transform: translateY(-4px);
}
.pin-auth-page .pin-input-group input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.pin-auth-page .pin-input-group.has-error {
  animation: shake 0.35s ease;
}
.pin-auth-page .pin-input-group.has-error input {
  border-color: #fb7185;
}
.pin-auth-page .pin-error {
  color: #fecdd3;
  background: rgba(239, 68, 68, 0.16);
  border: 1px solid rgba(248, 113, 113, 0.35);
  padding: 10px 12px;
  border-radius: 12px;
  font-size: 14px;
  margin-bottom: 16px;
}
.pin-auth-page .pin-submit-btn {
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, #06b6d4, #8b5cf6);
  color: white;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s ease;
}
.pin-auth-page .pin-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(6, 182, 212, 0.3);
}
.pin-auth-page .pin-submit-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.pin-auth-page .pin-clear-btn {
  margin-top: 14px;
  border: none;
  background: transparent;
  color: #cbd5e1;
  font-size: 14px;
  cursor: pointer;
}
.pin-auth-page .pin-clear-btn:hover:not(:disabled) {
  color: #ffffff;
  text-decoration: underline;
}
.pin-auth-page .pin-clear-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(28px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes pulseIcon {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 12px 35px rgba(139, 92, 246, 0.5);
  }
  50% {
    transform: scale(1.06);
    box-shadow: 0 18px 45px rgba(6, 182, 212, 0.55);
  }
}
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-8px);
  }
  50% {
    transform: translateX(8px);
  }
  75% {
    transform: translateX(-5px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/PinAuthScreen/PinAuthScreen.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACJ;AAEI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,2CAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,+BAAA;AAAR;AAEQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AAAZ;AAGQ;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AADZ;AAKI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qDAAA;EACA,+CAAA;EACA,kCAAA;AAHR;AAKQ;EACI,eAAA;AAHZ;AAQI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AANR;AAQQ;EACI,qCAAA;EACA,2BAAA;AANZ;AASQ;EACI,YAAA;EACA,mBAAA;AAPZ;AAWI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AATR;AAWQ;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,2CAAA;EACA,qCAAA;EAGA,6BAAA;EACA,+CAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,oBAAA;EACA,wBAAA;AAXZ;AAaY;EACI,yGACI;AAZpB;AAgBY;EACI,qBAAA;EACA,6CAAA;EACA,2BAAA;AAdhB;AAiBY;EACI,YAAA;EACA,mBAAA;AAfhB;AAmBQ;EACI,2BAAA;AAjBZ;AAmBY;EACI,qBAAA;AAjBhB;AAsBI;EACI,cAAA;EACA,mCAAA;EACA,2CAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AApBR;AAuBI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,qDAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AArBR;AAuBQ;EACI,2BAAA;EACA,8CAAA;AArBZ;AAwBQ;EACI,mBAAA;EACA,YAAA;AAtBZ;AA0BI;EACI,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAxBR;AA0BQ;EACI,cAAA;EACA,0BAAA;AAxBZ;AA2BQ;EACI,mBAAA;EACA,YAAA;AAzBZ;AA6BI;EACI;IACI,UAAA;IACA,uCAAA;EA3BV;EA8BM;IACI,UAAA;IACA,iCAAA;EA5BV;AACF;AA+BI;EAEI;IAEI,mBAAA;IACA,+CAAA;EA/BV;EAkCM;IACI,sBAAA;IACA,+CAAA;EAhCV;AACF;AAmCI;EAEI;IAEI,wBAAA;EAnCV;EAsCM;IACI,2BAAA;EApCV;EAuCM;IACI,0BAAA;EArCV;EAwCM;IACI,2BAAA;EAtCV;AACF","sourcesContent":[".pin-auth-page {\n    min-height: 60vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n\n\n    .pin-card {\n        width: 100%;\n        max-width: 420px;\n        padding: 36px 28px;\n        border-radius: 26px;\n        background: rgb(0 0 0 / 85%);\n        box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);\n        backdrop-filter: blur(18px);\n        text-align: center;\n        color: #ffffff;\n        animation: cardFadeIn 0.6s ease;\n\n        h2 {\n            margin: 14px 0 8px;\n            font-size: 28px;\n            font-weight: 700;\n        }\n\n        p {\n            margin: 0 0 28px;\n            color: #cbd5e1;\n            font-size: 15px;\n        }\n    }\n\n    .pin-icon {\n        width: 78px;\n        height: 78px;\n        margin: 0 auto;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: linear-gradient(135deg, #8b5cf6, #06b6d4);\n        box-shadow: 0 12px 35px rgba(139, 92, 246, 0.5);\n        animation: pulseIcon 1.8s infinite;\n\n        span {\n            font-size: 36px;\n        }\n    }\n\n\n    .pin-back-btn {\n        position: absolute;\n        top: 18px;\n        left: 18px;\n        border: none;\n        background: rgba(255, 255, 255, 0.12);\n        color: #ffffff;\n        padding: 9px 14px;\n        border-radius: 12px;\n        font-size: 14px;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.25s ease;\n\n        &:hover:not(:disabled) {\n            background: rgba(255, 255, 255, 0.22);\n            transform: translateX(-3px);\n        }\n\n        &:disabled {\n            opacity: 0.5;\n            cursor: not-allowed;\n        }\n    }\n\n    .pin-input-group {\n        display: flex;\n        justify-content: center;\n        gap: 14px;\n        margin-bottom: 16px;\n\n        input {\n            width: 70px;\n            height: 72px;\n            border-radius: 18px !important;\n            border: 2px solid rgba(255, 255, 255, 0.22);\n            background: rgba(255, 255, 255, 0.14);\n            // Mobile browsers briefly reveal the latest password character.\n            // Hide the native glyph and render our own dot as soon as state is set.\n            color: transparent !important;\n            -webkit-text-fill-color: transparent !important;\n            text-shadow: none;\n            font-size: 80px !important;\n            font-weight: 700;\n            text-align: center;\n            outline: none;\n            transition: all 0.25s ease;\n            padding-bottom: 20px;\n            caret-color: transparent; // hides blinking cursor\n\n            &.pin-input--filled {\n                background:\n                    radial-gradient(circle at center, #030303 0 9px, transparent 10px),\n                    rgba(255, 255, 255, 0.14);\n            }\n\n            &:focus {\n                border-color: #22d3ee;\n                box-shadow: 0 0 0 4px rgba(34, 211, 238, 0.2);\n                transform: translateY(-4px);\n            }\n\n            &:disabled {\n                opacity: 0.6;\n                cursor: not-allowed;\n            }\n        }\n\n        &.has-error {\n            animation: shake 0.35s ease;\n\n            input {\n                border-color: #fb7185;\n            }\n        }\n    }\n\n    .pin-error {\n        color: #fecdd3;\n        background: rgba(239, 68, 68, 0.16);\n        border: 1px solid rgba(248, 113, 113, 0.35);\n        padding: 10px 12px;\n        border-radius: 12px;\n        font-size: 14px;\n        margin-bottom: 16px;\n    }\n\n    .pin-submit-btn {\n        width: 100%;\n        height: 50px;\n        border: none;\n        border-radius: 16px;\n        background: linear-gradient(135deg, #06b6d4, #8b5cf6);\n        color: white;\n        font-size: 16px;\n        font-weight: 700;\n        cursor: pointer;\n        transition: all 0.25s ease;\n\n        &:hover:not(:disabled) {\n            transform: translateY(-2px);\n            box-shadow: 0 14px 30px rgba(6, 182, 212, 0.3);\n        }\n\n        &:disabled {\n            cursor: not-allowed;\n            opacity: 0.7;\n        }\n    }\n\n    .pin-clear-btn {\n        margin-top: 14px;\n        border: none;\n        background: transparent;\n        color: #cbd5e1;\n        font-size: 14px;\n        cursor: pointer;\n\n        &:hover:not(:disabled) {\n            color: #ffffff;\n            text-decoration: underline;\n        }\n\n        &:disabled {\n            cursor: not-allowed;\n            opacity: 0.6;\n        }\n    }\n\n    @keyframes cardFadeIn {\n        from {\n            opacity: 0;\n            transform: translateY(28px) scale(0.96);\n        }\n\n        to {\n            opacity: 1;\n            transform: translateY(0) scale(1);\n        }\n    }\n\n    @keyframes pulseIcon {\n\n        0%,\n        100% {\n            transform: scale(1);\n            box-shadow: 0 12px 35px rgba(139, 92, 246, 0.5);\n        }\n\n        50% {\n            transform: scale(1.06);\n            box-shadow: 0 18px 45px rgba(6, 182, 212, 0.55);\n        }\n    }\n\n    @keyframes shake {\n\n        0%,\n        100% {\n            transform: translateX(0);\n        }\n\n        25% {\n            transform: translateX(-8px);\n        }\n\n        50% {\n            transform: translateX(8px);\n        }\n\n        75% {\n            transform: translateX(-5px);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
